import QuotationResultCardFcl from "./quotations-result-card-fcl.component";

export default QuotationResultCardFcl;
